import { render, staticRenderFns } from "./AssignUserRole.vue?vue&type=template&id=35ffdc5b&"
import script from "./AssignUserRole.vue?vue&type=script&lang=js&"
export * from "./AssignUserRole.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports